export default "__VITE_ASSET__b0495fcb__"